import CommissionRateEdit from "./Edit";
import {CommissionRateList} from "./List";
import  {CommissionRateView}  from "./View";
import CommissionRateCreate from "./Create";

export {CommissionRateList,CommissionRateEdit,CommissionRateView, CommissionRateCreate}